export const LABELS = {
  coreBasic: "CORE基礎編",
  coreActiveLearning: "CORE実践編",
  base: "BASE",
};
